import React from "react";
import { Modal, Button } from "react-bootstrap";

const PushToSapStatusModal = ({
    show,
    handleClose,
    currentStatus,
    nextStatus,
    loading,
    onConfirm,
}) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Push to SAP Status</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>
                    Push to SAP is currently{" "}
                    <strong>{currentStatus ? "ENABLED" : "DISABLED"}</strong>.
                </p>

                <p className="mb-0">
                    Are you sure you want to{" "}
                    <strong>{nextStatus ? "ENABLE" : "DISABLE"}</strong>{" "}
                    Push to SAP?
                </p>

                <div className="mt-3 text-muted" style={{ fontSize: 12 }}>
                    The current status was pulled again from the API before showing this confirmation.
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={handleClose}
                    disabled={loading}
                >
                    Cancel
                </Button>

                <Button
                    variant={nextStatus ? "success" : "danger"}
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading
                        ? "Updating..."
                        : nextStatus
                            ? "Yes, Enable"
                            : "Yes, Disable"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PushToSapStatusModal;